import { Icon16Checkmark, Typography } from "@cur8/maneki";
import { Measurement } from "@cur8/rich-entity";
import { MetricConfig } from "./measurementConfig";
import styles from "./styles.module.sass";

interface MeasurementTileProps {
  config: MetricConfig;
  measurement: Measurement | undefined;
  onClick: () => void;
}

export function MeasurementTile({
  config,
  measurement,
  onClick,
}: MeasurementTileProps) {
  const isDone = measurement != null;
  const displayValue = formatMeasurementValue(config, measurement);

  return (
    <button
      type="button"
      className={styles.tile}
      data-done={isDone || undefined}
      onClick={onClick}
    >
      <div className={styles.tileHeader}>
        <Typography variant="label-s">{config.label}</Typography>
        {isDone && (
          <span className={styles.tileCheck}>
            <Icon16Checkmark />
          </span>
        )}
      </div>
      <Typography variant="body-s" color={isDone ? "inverted" : "subtle"}>
        {displayValue ?? config.dimensions.map((d) => d.unit).join(" / ")}
      </Typography>
    </button>
  );
}

function formatMeasurementValue(
  config: MetricConfig,
  measurement: Measurement | undefined
): string | undefined {
  if (!measurement) {
    return undefined;
  }

  const parts = config.dimensions.map((dimConfig) => {
    const dim = measurement.dimensions.find((d) => d.name === dimConfig.name);
    if (dim == null) {
      return null;
    }
    return `${dim.value} ${dimConfig.unit}`;
  });

  const validParts = parts.filter(Boolean);
  return validParts.length > 0 ? validParts.join(" / ") : undefined;
}
